import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { AppProductView } from "./appProductView.component";
import {MobileAppProductView} from "../mobile-appproduct-view/mobile-appProductView.component";

export function showAppProductViewModal(modalService: NgbModal, mobileMode: string = 'desktop') {
    const mobile = mobileMode != 'desktop';
    const component = mobile? MobileAppProductView: AppProductView;
    const windowClass = "dark-modal largeW1Window" + (mobile? ' mobile': '');
    let m: NgbModalRef = modalService.open(component, {
        backdrop: "static",
        size: "lg",
        centered: true,
        windowClass: windowClass
    });
    let modal = (<AppProductView>m.componentInstance);
    return modal;
}
